import { useQuery } from "@tanstack/react-query";

import { initUseQuery, queryKey } from "simplydo/core/query";
import SearchParams from "simplydo/core/searchParams";
import type { UserMe } from "simplydo/interfaces/types/userTypes";

import api from "api";

export const useMe = (): UserMe | undefined => {
  const utmReferrer =
    typeof window !== "undefined" && window.location
      ? new SearchParams(window.location.search).get("utm-link")
      : undefined;
  // Shares the cache entry the session resume and `setQueryData` calls use; the
  // UTM referrer only matters for the request, not the cached user.
  const { data: me } = useQuery({
    ...initUseQuery(api.users.me, [utmReferrer ?? ""]),
    queryKey: queryKey(api.users.me),
  });

  return me as UserMe | undefined;
};
